import React from "react";
import hostingData from "../jsonData/hosting.json";
import * as Wis from "../style/webbutv-details-style";
import { BokaMote } from "../style/bokaMote";
import AM from "../../assets/portraits/AM_portrait.jpg";

interface HostingContent {
  id: string;
  HostingInfoHeader: string;
  text1: string;
  text2: string;
}

const typedHostingData: HostingContent[] = hostingData;

export const HostingInfo: React.FC = () => {
  return (
    <Wis.BuildWebbContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "90%",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <Wis.BackArrow />
      </div>
      <Wis.BuildWebbIntroHead>
        Webbutveckling – Hosting & Förvaltning
      </Wis.BuildWebbIntroHead>
      <Wis.BuildWebHeader>Hosting & Förvaltning</Wis.BuildWebHeader>
      <Wis.Underline />
      <Wis.TwoContainer>
        {typedHostingData.slice(0, 2).map((content) => (
          <Wis.Section key={content.id}>
            <Wis.BuildWebHeading>
              {content.HostingInfoHeader}
            </Wis.BuildWebHeading>
            <Wis.BuildWebParagraph>{content.text1}</Wis.BuildWebParagraph>
            <Wis.BuildWebParagraph>{content.text2}</Wis.BuildWebParagraph>
          </Wis.Section>
        ))}
      </Wis.TwoContainer>

      <Wis.FullWidthContainer>
        <Wis.Section>
          <Wis.BuildWebHeading>
            {typedHostingData[2].HostingInfoHeader}
          </Wis.BuildWebHeading>
          <Wis.BuildWebParagraph>
            {typedHostingData[2].text1}
          </Wis.BuildWebParagraph>
          <Wis.BuildWebParagraph>
            {typedHostingData[2].text2}
          </Wis.BuildWebParagraph>
        </Wis.Section>
      </Wis.FullWidthContainer>

      <BokaMote 
          name="Andrea" 
          img={AM} 
          text="Boka ett möte med {name}." 
          email="hello@antech.se"
          subject="Bokningsförfrågan: Möte med Andrea"
          body="Hej {name}, Jag är intresserad av att veta mer om webbutveckling & hosting och skulle gärna boka ett möte med dig."
      />
    </Wis.BuildWebbContainer>
  );
};
